var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kendo-notification',{ref:"notificationRef",attrs:{"autoHideAfter":0,"templates":_vm.templates,"hideOnClick":false,"button":true,"closable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }